import {KeyMapped, mapById, Optional} from '@peachy/utility-kit-pure'
import {BenefitType, Excess, MrPlanBenefit} from '@peachy/core-domain-pure'
import * as PlanConfig from '@peachy/product-client'

/**
 * Returns a collection of PlanBenefit objects from a plan config benefit
 *
 * @param benefit
 * @param planExcess
 * @returns
 */
export function mapToPlanBenefit (benefit: PlanConfig.Benefit, planExcess?: Excess): MrPlanBenefit[] {
    const mapLimit = (benefitType: string) => {
        return typeof benefit.defaultLimit === 'object' ? benefit.defaultLimit[benefitType] : benefit.defaultLimit
    }

    return benefit.benefitTypes.map(benefitType => {
        const planBenefit = {
            id: benefitType,
            limit: mapLimit(benefitType)
        } as MrPlanBenefit

        if (planExcess?.benefitTypes?.includes(benefit.id as BenefitType)) {
            planBenefit.benefitSpecificExcess = false
            planBenefit.excess = planExcess.amountInPence
        }
        return planBenefit
    })
}

/**
 * Returns a collection of PlanBenefit objects mapped from plan config benefits.
 *
 * Note:
 *  - Benefits that are not active are not mapped
 *  - A single Benefit may produce multiple PlanBenefit objects
 *  - The defaultLimit for the benefit is used
 *
 * @param benefits
 * @param planExcess
 * @returns
 */
export function mapToPlanBenefits (benefits: PlanConfig.Benefit[], planExcess?: Excess): KeyMapped<MrPlanBenefit> {

    const planBenefits = benefits.flatMap(benefit => {
        if (!benefit.isActive) return
        return mapToPlanBenefit(benefit, planExcess)
    })

    return mapById(planBenefits.filter(b => !!b))
}

export function mapToExcess (excess?: PlanConfig.Excess): Optional<Excess> {
    if (excess) {
        //NOTE: as this'll end up in the store, we can't return this as an actual Excess object since it won't be reactive
        return {
            id: excess.id,
            amountInPence: excess.defaultLimit,
            benefitTypes: excess.benefitTypes
        } as Excess
    }
}
